import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportMonthlyInventory } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import PageHeader from 'screens/components/basic/PageHeader';
import { getMonthlyInventory, getCsvReport } from 'actions/ReportsAction';
import { getProductTypes } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import WithRouter from 'custom/withRouter';


class MonthlyInventory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date.getFullYear(), `MonthlyInventoryReportYear`);
        this.props.getProductTypes();
    }

    getReport = () => {
        let branch = this.props.selectedBranch;
        let selectedYear = this.props.selectedYear;
        let selectedMonth = this.props.selectedMonth;
        let category = this.props.selectedCategory;
        let iscannabis = this.props.isCannabis;
        this.props.getMonthlyInventory({ branch, selectedYear, selectedMonth, category, iscannabis });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranch;
        let selectedYear = this.props.selectedYear;
        let selectedMonth = this.props.selectedMonth;
        let category = this.props.selectedCategory;
        let iscannabis = this.props.isCannabis;
        this.props.getCsvReport(`reports/excel/monthlyinventory?branch=${branch}&year=${selectedYear}&month=${selectedMonth}&subcategoryId=${category}&iscannabis=${iscannabis}`, "monthlyInventoryReport");
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }


    render() {

        let categories = [];
        categories.push({ text: "All", value: "0", isCannabis: false }, { text: "All", value: "0", isCannabis: true });
        const cat = this.props.productTypes.length > 0 ? this.props.productTypes[0].categories : [];
        cat.map(item => {
            categories.push({
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            });
        });

        categories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });

        return (
            <Grid headerContent={reportMonthlyInventory}>
                <PageHeader title={LOOKUP.report.MonthlyInventory.text}
                    description={LOOKUP.report.MonthlyInventory.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    categories={categories}
                    isCannabisOptions={this.props.isCannabisOptions}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body monthlyInventory={this.props.monthlyInventory} selectedDate={this.props.selectedDate} allAccess={this.props.allAccess} selectedMonthText={this.props.selectedMonthText} selectedYear={this.props.selectedYear} />

                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];

    return {
        brachOptions: brachOptions,
        loggedBranch: state.common.branchId,
        selectedBranch: state.form.MonthlyInventoryReportBranch,
        selectedYear: state.form.MonthlyInventoryReportYear,
        selectedMonthText: state.form.MonthlyInventoryReportMonthText,
        selectedMonth: state.form.MonthlyInventoryReportMonth,
        monthlyInventory: state.reports.monthlyInventory,
        productTypes: state.entity.productTypesList,
        selectedCategory: state.form.MonthlyInventoryReportSelectedCategory,
        isCannabis: state.form.MonthlyInventoryReportIsCannabis,
        isCannabisOptions: isCannabis,
        allAccess: state.common.authenticatedUser ? !state.common.authenticatedUser.roles.includes("SalesLeads") ? true : false : false
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getMonthlyInventory: (model) => dispatch(getMonthlyInventory(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(MonthlyInventory));
